import { render, staticRenderFns } from "./SeckillDetails3.vue?vue&type=template&id=46796149&scoped=true&"
import script from "./SeckillDetails3.vue?vue&type=script&lang=js&"
export * from "./SeckillDetails3.vue?vue&type=script&lang=js&"
import style0 from "./SeckillDetails3.vue?vue&type=style&index=0&id=46796149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46796149",
  null
  
)

export default component.exports